import moonIconDark from '../static/images/moon_icon_dark.png'
import sunIconLight from '../static/images/sun_icon_light.png'

import { useTheme } from '../theme/ThemeContext';

function ThemeToggle({ title = "Toggle Theme" }) {
    const { theme, toggleTheme } = useTheme();

    const themeButtonStyle = {
        backgroundColor: 'rgba(0, 0, 0, 0.0)',
        border: 'none',
        padding: '0.5rem 1rem',
        borderRadius: '0.5rem',
        cursor: 'pointer'
    };

    const iconStyle = {
        height: '1.5em',
    };

    const moonIcon = <img src={moonIconDark} alt="Dark Mode" style={iconStyle} />
    const sunIcon = <img src={sunIconLight} alt="Light Mode" style={iconStyle} />


    return (
        <button onClick={toggleTheme} style={themeButtonStyle} title={title}>
            {/* {theme.name === 'light' ? '🌙' : '☀️'} */}
            {theme.name === 'light' ? moonIcon : sunIcon}
        </button>
    );
}

export default ThemeToggle